export default __webpack_public_path__ + "static/media/BeatTrap.fbca6f88.mp3";